export default "__VITE_ASSET__BLKyesYb__"